import { render, staticRenderFns } from "./unlimited_plan.vue?vue&type=template&id=2ad23f02&scoped=true&"
import script from "./unlimited_plan.vue?vue&type=script&lang=js&"
export * from "./unlimited_plan.vue?vue&type=script&lang=js&"
import style0 from "./unlimited_plan.vue?vue&type=style&index=0&id=2ad23f02&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ad23f02",
  null
  
)

export default component.exports